import React from 'react';
import { Tabs, Tab, Card } from 'react-bootstrap';
import ChalanItemsTableForReturnAndUpdate from './ChalanItemsTableForReturnAndUpdate';
import ChalanReturnForm from './ChalanReturnForm';
import ChalanDetailUpdateForm from './ChalanDetailUpdateForm';
import ChalanItemCostChangeForm from './ChalanItemCostChangeForm';
import StoreTransferForm from './StoreTransferForm';

function ChalanUpdateReturnTabs({ is_stock_return, is_transfer = false }) {
  return (
    <>
      <Card>
        <Card.Body className="pt-0">
          <Tabs
            defaultActiveKey="chalanDetail"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab
              eventKey="chalanDetail"
              title="Detail"
            >
              {/*chalan detail update form*/}
              <ChalanDetailUpdateForm is_stock_return={is_stock_return} />
            </Tab>
            <Tab
              eventKey="items"
              title="Items"
            >
              {/*chalan items*/}
              <ChalanItemsTableForReturnAndUpdate />

              {/*items update and return tabs*/}
              <Tabs
                defaultActiveKey={!is_stock_return ? 'update' : 'return'}
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                {!is_stock_return && (
                  <Tab
                    eventKey="update"
                    title="Update"
                  >
                    {/*chalan item cost change*/}
                    <ChalanItemCostChangeForm />
                  </Tab>
                )}
                <Tab
                  eventKey="return"
                  title={is_transfer ? 'Transfer' : 'Return'}
                >
                  {/*chalan return form*/}
                  {is_transfer ? <StoreTransferForm /> : <ChalanReturnForm is_stock_return={is_stock_return} />}
                </Tab>
              </Tabs>
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </>
  );
}

export default ChalanUpdateReturnTabs;
